import { render, staticRenderFns } from "./bahanbaku.vue?vue&type=template&id=fe03e8e6&scoped=true&"
import script from "./bahanbaku.vue?vue&type=script&lang=js&"
export * from "./bahanbaku.vue?vue&type=script&lang=js&"
import style0 from "./bahanbaku.vue?vue&type=style&index=0&id=fe03e8e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe03e8e6",
  null
  
)

export default component.exports